import { call, fork, put, takeEvery } from 'redux-saga/effects';

import actionTypes from '@atom/actions/actionTypes';
import * as inventorySchemaActions from '@atom/actions/inventorySchemaActions';
import accountUtilities from '@atom/utilities/accountUtilities';
import api from '@atom/utilities/api';
import {
  INVENTORY_ASSETS_ENDPOINT,
  INVENTORY_SCHEMAS_ENDPOINT,
} from '@atom/utilities/endpoints';

export function* getInventorySchemaDetail({ data: { id } }) {
  try {
    const endpoint = `${INVENTORY_SCHEMAS_ENDPOINT}/${id}`;
    const { data } = yield call(api.get, endpoint);

    yield put(inventorySchemaActions.getInventorySchemaSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getInventorySchemaFailure,
    );
  }
}

export function* getFullInventorySchemaDetail({ data: { id } }) {
  try {
    const endpoint = `${INVENTORY_SCHEMAS_ENDPOINT}/${id}/fulltree`;

    const { data } = yield call(api.get, endpoint);

    yield put(inventorySchemaActions.getSchemaDetailSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getSchemaDetailFailure,
    );
  }
}

export function* getInventorySchemaByAssetIdDetail({ data: { id } }) {
  try {
    const assetEndpoint = `${INVENTORY_ASSETS_ENDPOINT}/${id}`;

    const {
      data: { schemaId },
    } = yield call(api.get, assetEndpoint);

    const schemaEndpoint = `${INVENTORY_SCHEMAS_ENDPOINT}/${schemaId}`;

    const { data } = yield call(api.get, schemaEndpoint);

    yield put(inventorySchemaActions.getInventorySchemaSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getInventorySchemaFailure,
    );
  }
}

export function* getInventorySchemasList({
  data: { rootSchemas, isPublished },
}) {
  try {
    const params = {
      ...(rootSchemas ? { rootSchemas } : {}),
      ...(isPublished ? { isPublished } : {}),
    };

    const { data } = yield call(api.get, INVENTORY_SCHEMAS_ENDPOINT, params);

    yield put(inventorySchemaActions.getInventorySchemasSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getInventorySchemasFailure,
    );
  }
}

export function* getSchemasByIds({
  data: { parentSchemaId, fieldId, isPublished },
}) {
  try {
    const params = {
      ...(parentSchemaId ? { parentSchemaId } : {}),
      ...(isPublished ? { isPublished } : {}),
    };

    const { data } = yield call(api.get, INVENTORY_SCHEMAS_ENDPOINT, params);

    yield put(
      inventorySchemaActions.getSchemasByIdsSuccess({ schemas: data, fieldId }),
    );
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getSchemasByIdsFailure,
    );
  }
}

export function* getInventorySchemaTreeNode({ data: { id, elementPath } }) {
  try {
    const endpoint = `${INVENTORY_SCHEMAS_ENDPOINT}/${id}`;
    const {
      data: { elementGroups },
    } = yield call(api.get, endpoint);
    const data = {
      elementGroups,
      elementPath,
    };

    yield put(inventorySchemaActions.getInventorySchemaTreeNodeSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getInventorySchemaTreeNodeFailure,
    );
  }
}

export function* getSchemaTree({ data: { id } }) {
  try {
    const endpoint = `${INVENTORY_SCHEMAS_ENDPOINT}/${id}/tree`;
    const { data } = yield call(api.get, endpoint);

    yield put(inventorySchemaActions.getSchemaTreeSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.getSchemaTreeFailure,
    );
  }
}

export function* updateSchemaTree({ data }) {
  try {
    yield put(inventorySchemaActions.updateSchemaTreeSuccess(data));
  } catch (error) {
    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      inventorySchemaActions.updateSchemaTreeFailure,
    );
  }
}

export function* clearInventorySchema() {
  yield put(inventorySchemaActions.clearInventorySchemaSuccess());
}

/* WATCHERS */

export function* retrieveInventorySchema() {
  yield takeEvery(
    // @ts-ignore
    actionTypes.REQUEST_INVENTORY_SCHEMA,
    getInventorySchemaDetail,
  );
}

export function* retrieveInventorySchemaDetail() {
  yield takeEvery(
    // @ts-ignore
    actionTypes.REQUEST_SCHEMA_DETAIL,
    getFullInventorySchemaDetail,
  );
}

export function* retrieveInventorySchemaByAssetId() {
  yield takeEvery(
    // @ts-ignore
    actionTypes.REQUEST_INVENTORY_SCHEMA_BY_ASSET_ID,
    getInventorySchemaByAssetIdDetail,
  );
}

export function* retrieveInventorySchemas() {
  yield takeEvery(
    // @ts-ignore
    actionTypes.REQUEST_INVENTORY_SCHEMAS,
    getInventorySchemasList,
  );
}

export function* retrieveSchemasByIds() {
  // @ts-ignore
  yield takeEvery(actionTypes.REQUEST_SCHEMA_BY_IDS, getSchemasByIds);
}

export function* retrieveInventorySchemaTreeNode() {
  yield takeEvery(
    // @ts-ignore
    actionTypes.REQUEST_INVENTORY_SCHEMA_TREE_NODE,
    getInventorySchemaTreeNode,
  );
}

export function* retrieveSchemaTree() {
  // @ts-ignore
  yield takeEvery(actionTypes.REQUEST_SCHEMA_TREE, getSchemaTree);
}

export function* requestUpdateSchemaTree() {
  // @ts-ignore
  yield takeEvery(actionTypes.REQUEST_SCHEMA_TREE_UPDATE, updateSchemaTree);
}

export function* requestInventorySchemaClear() {
  yield takeEvery(
    actionTypes.REQUEST_INVENTORY_SCHEMA_CLEAR,
    clearInventorySchema,
  );
}

export default [
  retrieveInventorySchema,
  retrieveInventorySchemaDetail,
  retrieveInventorySchemaByAssetId,
  retrieveInventorySchemas,
  retrieveInventorySchemaTreeNode,
  retrieveSchemaTree,
  requestUpdateSchemaTree,
  retrieveSchemasByIds,
  requestInventorySchemaClear,
];
